import { useEffect } from 'react'

/**
 * custom hook to check visibility of a DOM element
 * @param {Obj} ref DOM element
 * @param {Number} visibilityThreshold indicate at what percentage of the target's
 * @param {Function} callback
 * visibility the observer's callback should be executed
 * @param {Boolean} elementReady - whether the element ref is ready
 */
// eslint-disable-next-line import/prefer-default-export
export function useOnScreen (ref, visibilityThreshold, callback, elementReady = true) {
  useEffect(() => {
    if (!elementReady) {
      return
    }

    const element = ref.current
    if (!element) {
      return
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        // Check intersectionRatio to ensure the element meets the visibility threshold
        // isIntersecting alone doesn't respect the threshold percentage
        callback(entry.intersectionRatio >= visibilityThreshold)
      },
      { threshold: visibilityThreshold },
    )

    observer.observe(element)

    // eslint-disable-next-line consistent-return
    return () => {
      if (element) {
        observer.unobserve(element)
      }
    }
  }, [elementReady, visibilityThreshold, callback, ref])
}
